(function () {
  'use strict';

  var SHOPIFY_STOREFRONT = {
    domain: 'caseteroid-world.myshopify.com',
    apiVersion: '2025-10',
    token: '19036fccaffbf1d598a2c10518f434c2'
  };

  function storefrontQuery(query, variables) {
    return fetch('https://' + SHOPIFY_STOREFRONT.domain + '/api/' + SHOPIFY_STOREFRONT.apiVersion + '/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': SHOPIFY_STOREFRONT.token
      },
      body: JSON.stringify({ query: query, variables: variables })
    }).then(function (r) { return r.json(); });
  }

  function parseGender(metafieldValue) {
    // custom.product_gender_context is stored as a JSON-array-string, e.g. '["female"]'
    if (!metafieldValue) return 'unisex';
    try {
      var parsed = JSON.parse(metafieldValue);
      if (Array.isArray(parsed) && parsed.length) return parsed[0];
      if (typeof parsed === 'string') return parsed;
    } catch (e) {
      // not JSON — treat the raw string as the value
      return metafieldValue;
    }
    return 'unisex';
  }

  function fetchProductsByModelTag(modelTag, first) {
    var gql =
      'query($q: String!, $first: Int!) {' +
      '  products(first: $first, query: $q, sortKey: CREATED_AT, reverse: true) {' +
      '    edges {' +
      '      node {' +
      '        handle' +
      '        title' +
      '        tags' +
      '        featuredImage { url altText }' +
      '        priceRange { minVariantPrice { amount currencyCode } }' +
      '        genderMetafield: metafield(namespace: "custom", key: "product_gender_context") { value }' +
      '      }' +
      '    }' +
      '  }' +
      '}';
    var q = "tag:'" + modelTag + "'";
    return storefrontQuery(gql, { q: q, first: first || 100 }).then(function (res) {
      if (res.errors) {
        console.error('Storefront API error:', res.errors);
        return [];
      }
      return res.data.products.edges.map(function (e) {
        var node = e.node;
        var design = (node.title.split(' - ')[0] || node.title).trim();
        return {
          handle: node.handle,
          title: node.title,
          design: design,
          gender: parseGender(node.genderMetafield && node.genderMetafield.value),
          image: node.featuredImage ? node.featuredImage.url : '',
          alt: node.featuredImage ? (node.featuredImage.altText || node.title) : node.title,
          price: node.priceRange && node.priceRange.minVariantPrice
            ? Math.round(parseFloat(node.priceRange.minVariantPrice.amount) * 100)
            : 0,
          currencyCode: node.priceRange && node.priceRange.minVariantPrice
            ? node.priceRange.minVariantPrice.currencyCode
            : null
        };
      });
    });
  }

  function fetchJSON(url) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('Failed to fetch ' + url);
      return r.json();
    });
  }

  function formatMoney(cents, currencyCode) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function isMenMode() {
    var params = new URLSearchParams(window.location.search);
    var view = params.get('view') || '';
    return view.indexOf('men') !== -1 || sessionStorage.getItem('gender') === 'men';
  }

  function buildCard(item, currencyCode, deviceLabel) {
    var a = document.createElement('a');
    a.className = 'wtyl-card';
    a.href = '/products/' + item.handle;
    a.innerHTML =
      '<div class="wtyl-card__media" data-media></div>' +
      '<div class="wtyl-card__body">' +
        '<p class="wtyl-card__title">' + item.design + '</p>' +
        '<p class="wtyl-card__subtitle">' + deviceLabel + '</p>' +
        '<p class="wtyl-card__price" data-price></p>' +
      '</div>';

    var mediaEl = a.querySelector('[data-media]');
    var priceEl = a.querySelector('[data-price]');
    mediaEl.innerHTML = '<img src="' + (item.image || '') + '" alt="' + item.alt + '" loading="lazy" />';
    priceEl.textContent = formatMoney(item.price, item.currencyCode || currencyCode);

    return a;
  }

  function setupScrollThumb(container, grid) {
    var thumb = container.querySelector('[data-scroll-thumb]');
    if (!thumb) return;

    function update() {
      var scrollable = grid.scrollWidth - grid.clientWidth;
      if (scrollable <= 0) {
        thumb.parentElement.style.display = 'none';
        return;
      }
      thumb.parentElement.style.display = 'block';
      var thumbWidthPct = Math.max((grid.clientWidth / grid.scrollWidth) * 100, 10);
      var maxLeftPct = 100 - thumbWidthPct;
      var scrollPct = grid.scrollLeft / scrollable;
      thumb.style.width = thumbWidthPct + '%';
      thumb.style.left = (scrollPct * maxLeftPct) + '%';
    }

    grid.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
    setTimeout(update, 300);
    setTimeout(update, 1000);
  }

  function init(container) {
    if (container.dataset.initialized) return;
    container.dataset.initialized = 'true';

    var currentHandle = container.dataset.currentHandle;
    var currentDevice = container.dataset.currentDevice || '';
    var modelTag = container.dataset.modelTag;
    var limit = parseInt(container.dataset.limit, 10) || 12;
    var grid = container.querySelector('[data-grid]');

    if (!modelTag) {
      container.style.display = 'none';
      return;
    }

    Promise.all([
      fetchProductsByModelTag('model:' + modelTag, 100),
      fetchJSON('/cart.js')
    ]).then(function (results) {
      var items = results[0];
      var cartCurrency = results[1].currency;
      var currencyCode = (typeof cartCurrency === 'string')
        ? cartCurrency
        : ((cartCurrency && cartCurrency.active) || 'USD');

      var isMen = isMenMode();

      var filtered = items.filter(function (item) {
        if (item.handle === currentHandle) return false;
        if (isMen) return item.gender === 'male' || item.gender === 'unisex';
        return item.gender === 'female' || item.gender === 'unisex';
      });

      filtered = filtered.slice(0, limit);

      if (filtered.length === 0) {
        container.style.display = 'none';
        return;
      }

      filtered.forEach(function (item) {
        grid.appendChild(buildCard(item, currencyCode, currentDevice));
      });

      setupScrollThumb(container, grid);
    }).catch(function (err) {
      console.error('We Think You\'ll Love error:', err);
    });
  }

  function initAll() {
    document.querySelectorAll('[id^="WeThinkYoullLove-"]').forEach(function (el) {
      init(el);
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
})();
